module.exports = __webpack_public_path__ + "img/supercharged_support.2e91a2cd.svg";